import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useArchiveInventoryLocationMutation } from '../../../../graphql'

export default function useArchiveInventoryLocationHandler( options?: any ) {
	const [ archiveLocation ] = useArchiveInventoryLocationMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( id: string ) => {
		const result = await archiveLocation( { variables: {
			inventoryLocationId: parseInt( id, 10 ),
		} } )
		if ( result.data?.archiveInventoryLocation?.success ) {
			showSuccess( `archiveInventoryLocationSuccess${Date.now()}`, result.data.archiveInventoryLocation.message ?? 'Successfully archived store' )
		} else {
			showError( `createInventoryLocationError${Date.now()}`, result.data?.archiveInventoryLocation?.message ?? 'Sorry, an error occurred' )
		}
	}
}
